export default {
  sizes: {},
  defaultProps: {
    colorScheme: 'primary',
  },
}
